import React from 'react';
import { menuCategories } from '../mock';
import { Button } from '../components/ui/button';

export const Dining = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section
        className="relative h-96 flex items-center justify-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1920&q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0" style={{ backgroundColor: 'rgba(16, 40, 84, 0.7)' }} />
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
            Food & Beverage
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            A culinary journey crafted with passion, precision, and the finest ingredients
          </p>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-16 px-4 bg-white">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ color: '#102854' }}>
            Exceptional Dining Experience
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-4">
            At Pauline Hotels, dining is more than just a meal—it's an experience. Our talented chefs combine 
            culinary artistry with premium ingredients to create dishes that delight the senses and nourish the soul.
          </p>
          <p className="text-lg text-gray-600 leading-relaxed">
            From hearty breakfast spreads to elegant fine dining and handcrafted cocktails, every menu item 
            reflects our commitment to quality, flavor, and presentation.
          </p>
        </div>
      </section>

      {/* Menu Section */}
      <section className="py-16 px-4" style={{ backgroundColor: '#f9fafb' }}>
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#102854' }}>
              Our Menu
            </h2>
            <p className="text-lg text-gray-600">
              Menu will be uploaded soon.
            </p>
          </div>
        </div>
      </section>

      {/* Dining Features */}
      <section className="py-16 px-4 bg-white">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ backgroundColor: '#FEF3E2' }}>
                <span className="text-3xl">🍳</span>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#102854' }}>
                All-Day Dining
              </h3>
              <p className="text-gray-600">
                Enjoy breakfast, lunch, and dinner prepared fresh throughout the day
              </p>
            </div>
            <div className="text-center p-6">
              <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ backgroundColor: '#FEF3E2' }}>
                <span className="text-3xl">🍷</span>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#102854' }}>
                Premium Bar
              </h3>
              <p className="text-gray-600">
                Expertly crafted cocktails and an extensive wine selection
              </p>
            </div>
            <div className="text-center p-6">
              <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ backgroundColor: '#FEF3E2' }}>
                <span className="text-3xl">🌟</span>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#102854' }}>
                Room Service
              </h3>
              <p className="text-gray-600">
                Full menu available for in-room dining at your convenience
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 px-4" style={{ backgroundColor: '#102854' }}>
        <div className="container mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Reserve Your Table
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Experience culinary excellence at Pauline Hotels. Book your dining experience today.
          </p>
          <Button
            asChild
            size="lg"
            className="font-semibold text-base px-8 py-6 transition-all hover:scale-105"
            style={{
              backgroundColor: '#C9A961',
              color: '#ffffff'
            }}
          >
            <a href="/contact">Make a Reservation</a>
          </Button>
        </div>
      </section>
    </div>
  );
};